import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, MailCheck } from "lucide-react";
import Logo from "@/components/Logo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Något gick fel");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-5 py-10">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl p-8">
        <div className="mb-6"><Logo variant="inline" size="md"/></div>
        <Link to="/login" data-testid="fp-back" className="text-xs text-slate-500 flex items-center gap-1 mb-4 hover:text-slate-900">
          <ArrowLeft size={14}/> Tillbaka till inloggning
        </Link>
        {!sent ? (
          <>
            <h1 className="font-heading text-3xl font-extrabold text-slate-900 mb-1">Glömt lösenord?</h1>
            <p className="text-sm text-slate-500 mb-6">Ange din e-post så skickar vi en återställningslänk. Länken är giltig i 1 timme.</p>
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label>E-postadress</Label>
                <Input required type="email" data-testid="fp-email" value={email} onChange={e => setEmail(e.target.value)} className="h-11"/>
              </div>
              <Button type="submit" data-testid="fp-submit" disabled={loading}
                className="w-full h-12 bg-[#E1251B] hover:bg-[#C81D14] text-white font-semibold rounded-full">
                {loading ? "Skickar…" : "Skicka återställningslänk"}
              </Button>
            </form>
          </>
        ) : (
          <div className="text-center py-4" data-testid="fp-success">
            <div className="w-14 h-14 rounded-full bg-emerald-100 mx-auto flex items-center justify-center mb-4">
              <MailCheck className="text-emerald-600" size={28}/>
            </div>
            <h2 className="font-heading text-2xl font-extrabold text-slate-900">Kontrollera din inkorg</h2>
            <p className="text-sm text-slate-600 mt-2">Om det finns ett konto för <span className="font-semibold">{email}</span> har vi skickat en återställningslänk. Kolla även skräpposten.</p>
            <Link to="/login" data-testid="fp-back-login" className="inline-block mt-6 text-sm font-semibold text-[#E1251B] hover:underline">Tillbaka till inloggning</Link>
          </div>
        )}
      </div>
    </div>
  );
}
